/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import BookingStepList from "../components/booking/steps/BookingStepList";
import ServiceCatalog from "../components/booking/service/ServiceCatalog";
import ClassItem from "../components/booking/class/ClassItem";
import { usePreparedClasses } from "../hooks/usePreparedClasses";
import { useClassSelection } from "../hooks/useClassSelection";
import { useBooking } from "../hooks/useBooking";
import { useDispatch } from "react-redux";
import { setFlow, FlowType } from "../store/slices/flowSlice";

const Classes = () => {
  const dispatch = useDispatch();
  const { selectedProvider, setSelectedProvider } = useBooking();
  const { selectedClass } = useClassSelection();
  const { classes, categoriesWithClasses, isLoading, noDataToDisplay } = usePreparedClasses();

  useEffect(() => {
    dispatch(setFlow(FlowType.BOOKING));
  }, []);

  useEffect(() => {
    if (selectedClass && selectedProvider?.id !== selectedClass.provider.id) {
      setSelectedProvider(selectedClass.provider);
    }
  }, [selectedClass, selectedProvider, setSelectedProvider]);

  return (
    <Container>
      <NavigationHeader location locationSelectable back="step" />
      <BookingStepList title="Select class">
        <ServiceCatalog
          categorized={categoriesWithClasses.length > 0}
          items={classes}
          categories={categoriesWithClasses}
          isLoading={isLoading}
          noDataToDisplay={noDataToDisplay}
          emptyMessage="No classes available"
          renderItem={(classItem, category) => (
            <ClassItem key={classItem.id} classItem={classItem} category={category} />
          )}
        />
      </BookingStepList>
    </Container>
  );
};

export default Classes;
